// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--1iLMj","content":"Card-module--content--ANZMs","heading":"Card-module--heading--rQq5X","featured":"Card-module--featured--2d9v8"};